import { Link } from 'react-router-dom';
import { categories } from '@/mocks/guagua';
import SectionHeading from '@/components/base/SectionHeading';

const toneClass: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function CategoryGrid() {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100" aria-labelledby="home-categories">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="Categorise"
          title="挑个方向，专挑你想看的瓜"
          desc="六个常驻栏目，按主题把热点分好类。想快速浏览某类动态，从这里进入最省事。"
        />
        <div id="home-categories" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((item) => (
            <Link
              key={item.slug}
              to={`/news?cat=${item.slug}`}
              className="group flex flex-col p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className={`flex items-center justify-center w-11 h-11 rounded-md text-xl ${toneClass[item.tone]}`}>
                <i className={item.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {item.name}
              </h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
              <span className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                <span>累计 {item.count} 条</span>
                <span className="flex items-center gap-1 text-primary-600 font-medium">
                  进入栏目
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}